import React, { Component } from 'react'

export default class NoHits extends Component {
  public render() {
    return (
      <h4>No results found. Please try again.</h4>
    )
  }
}
